'use strict';
import angular from 'angular';
import ngMessages from 'angular-messages';
import newShippingAddressController from './new-shipping-address.controller';
import AddressService from '../../forms/account/address/address.service';
import ngMaterial from 'angular-material';
export default angular.module('directives.newShippingAddress', [ngMessages, ngMaterial])
    .service('AddressService', AddressService)
    .component('newShippingAddress', {
    template: require('./new-shipping-address.html'),
    controller: newShippingAddressController,
    bindings: {
        address: '=',
        showUsOnly: '<'
    }
})
    .name;
//# sourceMappingURL=index.js.map